import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import es from '@/locales/es.json';

void i18n.use(initReactI18next).init({
  resources: { es: { translation: es } },
  lng: import.meta.env.VITE_DEFAULT_LOCALE ?? 'es',
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
